import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../../queries/withCount';

const ERRORS = `errors { path, message }`;

const USER_FIELDS = `
  id
  firstName
  lastName
  email
  phoneNumber { formatted, value}
  invitationSentAt
  invitationAcceptedAt
  role
  canBeHidden
  isHidden
  receivesReleases
  canApproveBuyer
  availableForChat
  userRoles
`

const USER_VARIABLES = `
  $email: String!
  $firstName: String!
  $lastName: String!
  $phoneNumber: String
  $role: String
  $receivesReleases: Boolean
  $canApproveBuyer: Boolean
`;

const EDIT_USER_VARIABLES = `
  $email: String
  $firstName: String
  $lastName: String
  $phoneNumber: String
  $role: String
  $password: String
  $receivesReleases: Boolean
  $canApproveBuyer: Boolean
  $defaultNotificationsEmail: Boolean
  $liveSaleNotificationsEmail: Boolean
  $userRoles: [String!]
`;

const USER_ARGUMENTS = `
  email: $email
  firstName: $firstName
  lastName: $lastName
  phoneNumber: $phoneNumber
  role: $role
  receivesReleases: $receivesReleases
  canApproveBuyer: $canApproveBuyer
`;

const USER_FIELDS_AND_ERRORS = `
  user {
    ${USER_FIELDS}
  }
  ${ERRORS}
`;

export const USERS_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    usersWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${USER_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser(
    ${USER_VARIABLES}
  ) {
    createUser(
      ${USER_ARGUMENTS}
    ) {
      ${USER_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $id: ID!
    ${EDIT_USER_VARIABLES}
    $availableForChat: Boolean
  ) {
    updateUser(
      id: $id
      password: $password
      ${USER_ARGUMENTS}
      defaultNotificationsEmail: $defaultNotificationsEmail
      liveSaleNotificationsEmail: $liveSaleNotificationsEmail
      userRoles: $userRoles
      availableForChat: $availableForChat
    ) {
      ${USER_FIELDS_AND_ERRORS}
    }
  }
`;

export const USER = gql`
  query User($id: ID!) {
    User(id: $id) {
      ${USER_FIELDS}
    }
  }
`;

export const HIDE_USER = gql`
  mutation HideUser($id: ID!) {
    hideUser(id: $id) {
      user {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const UNHIDE_USER = gql`
  mutation UnhideUser($id: ID!) {
    unhideUser(id: $id) {
      user {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const REINVITE_USER = gql`
  mutation ReinviteUser(
    $id: ID!
  ) {
    reinviteUser(
      id: $id
    ) {
      user { id }
      errors { message, path }
    }
  }
`;

